export const DEFAULT_CUSTOM_ELEMENT_URL_SERVER =
  'https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js';
export const DEFAULT_CUSTOM_ELEMENT_URL_CORVID =
  'https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElementCorvid.js';

export const initialPopupPosition = {
  top: 0,
  left: 0,
};

export const CUSTOM_ELEMENTS_DIRECTORY_NAME = 'custom-elements';
export const INVALID_TAG_NAMES = [
  'annotation-xml',
  'color-profile',
  'font-face',
  'font-face-src',
  'font-face-uri',
  'font-face-format',
  'font-face-name',
  'missing-glyph',
];

export const CUSTOM_ELEMENT_EMPTY_STATE_LEARN_MORE_URL =
  'https://support.wix.com/en/article/wix-editor-adding-a-custom-element-to-your-site';

export const shouldSanitizeSpec = 'specs.thunderbolt.sanitizeCustomElement';
